import * as React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActionArea,
  Box,
  Avatar,
} from "@mui/material";
import { Empresa } from "../../../Hooks/UsuarioHook";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../../Utils/Urls";
import { useEntidade } from "../../../Hooks/EntidadeHook";
import { cnpjMask, cpfMask } from "../../../Utils/mascaras";
import BusinessIcon from "@mui/icons-material/Business";

interface Props {
  empresa: Empresa;
}

export default function EmpresaCard({ empresa }: Props) {
  const navigate = useNavigate();
  const { entidade } = useEntidade();

  const handleNavigate = () => {
    navigate(`${app_base_url}/${entidade.banco}/firma/${empresa.CODIGO_FIRMA}`);
  };

  return (
    <Card
      sx={{
        width: 400,
        maxWidth: "95vw",
        m: 2,
        borderRadius: 3,
        boxShadow: 4,
        transition: "0.3s",
        ":hover": { boxShadow: 8 },
        cursor: "pointer",
      }}
      onClick={handleNavigate}
    >
      <CardActionArea>
        <CardContent>
          <Box display="flex" alignItems="center" gap={2}>
            <Avatar sx={{ bgcolor: "primary.main" }}>
              <BusinessIcon />
            </Avatar>
            <Box flex={1}>
              <Typography variant="h6" fontWeight="bold">
                {empresa.DESCRICAO}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {empresa.CNPJ && empresa.CNPJ.length === 14
                  ? cnpjMask(empresa.CNPJ)
                  : cpfMask(empresa.CPF || "")}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleNavigate();
              }}
            >
              Visualizar
            </Button>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
